import React from "react";

const TablePageLayout = ({ subtitle, cards = [], children }) => {
  return (
    <div className="flex h-full w-full min-h-0 flex-1 flex-col p-2">
      {/* Top Header & Cards Section (Fixed Height / Shrink-0) */}
      <div className="flex flex-shrink-0 flex-col gap-4 lg:flex-row lg:items-center lg:justify-between">
        {/* Metric Cards */}
        {cards.length > 0 && (
          <div className="flex flex-wrap gap-4">
            {cards.map((card, idx) => (
              <div
                key={idx}
                onClick={card.onClick}
                className={`header-card cursor-pointer transition-all hover:shadow-md ${
                  card.active
                    ? "border-2 border-[#02a9e0] ring-2 ring-[#02a9e0]/20"
                    : "border border-gray-100"
                }`}
              >
                <div className="flex items-center justify-between">
                  <p className="text-[12px] font-medium text-black-500">
                    {card.label}
                  </p>
                  {card.icon && (
                    <div
                      className={`flex h-8 w-8 items-center justify-center rounded-[7px] ${
                        card.bgClass || "bg-blue-50 text-blue-500"
                      }`}
                    >
                      {card.icon}
                    </div>
                  )}
                </div>
                <h3 className="mt-1 text-[25px] font-bold text-black-600">
                  {card.value}
                </h3>
              </div>
            ))}
          </div>
        )}

        {/* Subtitle Accent Bar */}
        {subtitle && (
          <div className="flex items-end gap-3 text-right">
            <div>
              <p className="mt-0.5 text-[18px] font-medium text-black-600">
                {subtitle}
              </p>
            </div>
            <div className="h-6 w-1.5 rounded-full bg-cyan-500" />
          </div>
        )}
      </div>

      {/* Main Content View (Flex-1 + min-h-0 forces dynamic expansion) */}
      <div className="table-page-content mt-3 flex min-h-0 flex-1 flex-col overflow-hidden">
        {children}
      </div>
    </div>
  );
};

export default TablePageLayout;